export const getDefaultPopupContainer = (triggerNode: HTMLElement) =>
  triggerNode.parentElement as HTMLElement;
